// extracted by mini-css-extract-plugin
export default {"tooltip":"ControlTooltip_tooltip__WmHHT"};